export default [
    {
        label: window.i18n.__('Janvier'),
        labelMinified: window.i18n.__('janv.'),
        month: '01',
        quarter: 1,
    },
    {
        label: window.i18n.__('Février'),
        labelMinified: window.i18n.__('fév.'),
        month: '02',
        quarter: 1,
    },
    {
        label: window.i18n.__('Mars'),
        labelMinified: window.i18n.__('mars'),
        month: '03',
        quarter: 1,
    },
    {
        label: window.i18n.__('Avril'),
        labelMinified: window.i18n.__('avr.'),
        month: '04',
        quarter: 2,
    },
    {
        label: window.i18n.__('Mai'),
        labelMinified: window.i18n.__('mai'),
        month: '05',
        quarter: 2,
    },
    {
        label: window.i18n.__('Juin'),
        labelMinified: window.i18n.__('juin'),
        month: '06',
        quarter: 2,
    },
    {
        label: window.i18n.__('Juillet'),
        labelMinified: window.i18n.__('juil.'),
        month: '07',
        quarter: 3,
    },
    {
        label: window.i18n.__('Août'),
        labelMinified: window.i18n.__('août'),
        month: '08',
        quarter: 3,
    },
    {
        label: window.i18n.__('Septembre'),
        labelMinified: window.i18n.__('sept.'),
        month: '09',
        quarter: 3,
    },
    {
        label: window.i18n.__('Octobre'),
        labelMinified: window.i18n.__('oct.'),
        month: '10',
        quarter: 4,
    },
    {
        label: window.i18n.__('Novembre'),
        labelMinified: window.i18n.__('nov.'),
        month: '11',
        quarter: 4,
    },
    {
        label: window.i18n.__('Décembre'),
        labelMinified: window.i18n.__('déc.'),
        month: '12',
        quarter: 4,
    },
];
